import React from "react";
class Register extends React.Component{
    constructor(props){
        super(props)
        this.state={
            mail:"",
            pass:"",
            name:""
        }
    }
    onNameChange=(event)=>{
        this.setState({name:event.target.value})
    }
    onMailChange=(event)=>{
        this.setState({mail:event.target.value});
    }
    onPasswordChange=(event)=>{
        this.setState({pass:event.target.value});
    }
    onRegister=()=>{
        console.log(this.state);
         let flag=false; 
        fetch('https://facedetection-backend-ramsundar07.onrender.com/register', {
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              name:this.state.name,
              email: this.state.mail,
              pass: this.state.pass
            })
          }).then(response=>response.json())
          .then(s=>{
          console.log("s.id",s.id);
          if(s.id){ 
            console.log("s",s);
            this.props.updateUser(s);
        }
       else{
        alert("Wrong Credentials / User already exist");
        this.props.changeRoute("reg");
       }
    });
    this.props.changeRoute("home");   
 }
    render(){
        const {changeRoute} = this.props;
        return(
            <article className="br5 ba b--black-10 w-100 w-50-m w-40-l mw8 bw1 shadow-5 center">
            <main className="pa4 black-80">
            <form className="measure">
                <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                <legend className="f2 fw6 ph0 mh0"><u>Register</u></legend>
                <div className="mt3">
                    <label className="db f4 fw6 lh-copy " htmlFor="name">Name</label>
                    <input onChange={this.onNameChange} className="pa2 input-reset ba bw1 b--black bg-transparent hover-bg-black hover-white w-100" type="text" name="name"  id="name"/>
                </div>
                <div className="mt3">
                    <label className="db f4 fw6 lh-copy " htmlFor="email-address">Email</label>
                    <input
                  className="pa2 input-reset ba bw1 b--black bg-transparent hover-bg-black hover-white w-100"
                  type="email"
                  name="email-address"
                  id="email-address"
                  onChange={this.onMailChange}
                />
                </div>
                <div className="mv3">
                    <label className="db f4 fw6 lh-copy " htmlFor="password">Password</label>
                    <input onChange={this.onPasswordChange} className="b pa2 input-reset ba bw1 b--black bg-transparent hover-bg-black hover-white w-100" type="password" name="password"  id="password"/>
                </div>
                
                </fieldset>
                <div className="">
                <input className="b ph3 pv2 input-reset ba bw2 b--black bg-transparent grow pointer f6 dib" type="submit" value="Register" onClick={this.onRegister}/>
                </div>
            
            </form>
            </main>
        </article>
        )
    }
}

export default Register;